import { useTranslation } from 'react-i18next';

import { ENUM_TABS } from 'constants/enum';

const AddFileIcon = require('assets/resources/AddFile.svg').default;
const CameraIcon = require('assets/resources/Camera.svg').default;
const FolderIcon = require('assets/resources/Folder.svg').default;
const HomeIcon = require('assets/resources/Home.svg').default;
const ListIcon = require('assets/resources/List.svg').default;

/**
 * @description Sidebar component for users detail page
 * @param {{ tabActive: ENUM_TABS, setTabActive: (tab: ENUM_TABS) => void }} props - Props
 * @param {ENUM_TABS} props.tabActive - Active tab
 * @param {Function} props.setTabActive - Function to set active tab
 */
const Sidebar = ({ tabActive, setTabActive, setBreadcrumbs }) => {
  const { t } = useTranslation();
  const tabs = [
    {
      id: ENUM_TABS.HOME,
      icon: HomeIcon,
      label: t('HOME'),
    },
    {
      id: ENUM_TABS.ANSWER_RESULT_LIST,
      icon: ListIcon,
      label: t('ANSWER_RESULT'),
    },
    {
      id: ENUM_TABS.ANSWER_RESULT_VIDEO,
      icon: CameraIcon,
      label: t('VIDEO_RESULT'),
    },
    {
      id: ENUM_TABS.REPORT_LIST,
      icon: FolderIcon,
      label: t('REPORT_LIST'),
    },
    {
      id: ENUM_TABS.REPORT_CREATE,
      icon: AddFileIcon,
      label: t('REPORT_CREATE'),
    },
  ];

  const handleTab = (tab) => {
    setTabActive(tab.id);
    setBreadcrumbs((prev) => {
      prev[1].title = tab.label.replace('<br />', ' ');
      return prev;
    });
  };

  return (
    <div className="py-2 flex flex-col gap-2">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`flex flex-col items-center justify-center w-20 h-20 rounded-lg ${tab.id === tabActive ? 'bg-teal-444/20' : 'bg-white'} gap-1 cursor-pointer`}
          onClick={() => handleTab(tab)}
        >
          <img width={18} height={18} src={tab.icon} alt={tab.label} />
          <div className="text-sm text-center" dangerouslySetInnerHTML={{ __html: tab.label }} />
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
